var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    { attrs: { width: "100%", flat: "", color: "ecbg" } },
    [
      _c("v-card-title", { staticClass: "hidden-sm-and-down" }, [
        _vm._v(_vm._s(_vm.$t("EditItem")))
      ]),
      _c(
        "v-card-text",
        [
          _vm.model
            ? _c("item-form", {
                attrs: { data: _vm.model },
                on: {
                  ok: function($event) {
                    return _vm.updateItem($event)
                  }
                }
              })
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }